import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
interface StateInterface {
  content: any;
}

const initialState: StateInterface = {
  content: {},
};

export const updateInfoSlicce = createSlice({
  name: "darkmode",
  initialState,
  reducers: {
    updateUserInfo: (state, { payload }): void => {
      state.content = payload;
    },
  },
});

export const { updateUserInfo } = updateInfoSlicce.actions;
export const userInfo = (state: RootState) => state.userInfoReducer.content;

export default updateInfoSlicce.reducer;
